import React, { useState, useEffect } from "react";
import { User11 } from "../../imagepath";
import { Link, useNavigate } from "react-router-dom";
//import {getIdData } from "../../../lib/studentinfo"
import { uploadFile, getFile, removeFile } from "../../../lib/file";
import { useAuth } from "../../../usercontext";
import { updateData, getIdData } from "../../../lib/profiles";

export default function ParentProfile() {
  const [parentInfo, setParentInfo] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [avatar, setAvatar] = useState("");
  const { profile, setProfile } = useAuth();
  const navigate = useNavigate();
  //const instructorId = "e7974e5e-a089-426e-ae53-d39742e05e84";

  async function ChangePhoto() {
    let file = selectedImage;
    let fileExt = file.name.split(".")[file.name.split(".").length - 1];
    let newFileName = profile.id + "." + fileExt;

    await uploadFile(newFileName, selectedImage);

    await updateData({
      id: profile.id,
      avatar_url: newFileName,
    });

    setProfile({ ...profile, avatar_url: newFileName });

    //await removeFile(profile.avatar_url);
  }

  async function GetData() {
    if (profile) {
      const info = await getIdData(profile.id);
      setParentInfo(info);
      const avt = await getFile(profile.avatar_url);
      setAvatar(avt.publicUrl);
    }
  }

  useEffect(() => {
    GetData();
    //console.log("EditProfile",profile);
  }, [profile]);
  return (
    <div className="col-xl-9 col-md-8 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>Profile Details</h3>
            <p>You have full control to manage your own account setting.</p>
          </div>
          <div className="course-group mb-0 d-flex">
            <div className="course-group-img d-flex align-items-center">
              <Link to="/students-profile">
                {selectedImage ? (
                  <img
                    src={URL.createObjectURL(selectedImage)}
                    alt=""
                    className="img-fluid"
                  />
                ) : (
                  <img
                    src={avatar ? avatar : User11}
                    alt=""
                    className="img-fluid"
                  />
                )}
              </Link>
              <div className="course-name">
                <h4>
                  <Link to="/students-profile">Your avatar</Link>
                </h4>
                <p>PNG or JPG no bigger than 800px wide and tall.</p>
              </div>
            </div>
            <div className="profile-share d-flex align-items-center justify-content-center">
              <div className="relative-form">
                <span>No File Selected</span>
                <label className="relative-file-upload">
                  Change Photo{" "}
                  <input
                    type="file"
                    name="myImage"
                    onChange={(event) => {
                      //console.log(event.target.files[0]);
                      setSelectedImage(event.target.files[0]);
                    }}
                  />
                </label>
              </div>{" "}
              &nbsp; &nbsp;
              <button onClick={ChangePhoto} className="btn btn-success">
                Update
              </button>
              {/*}
                      <Link to="#;" className="btn btn-success">
                        Update
                      </Link>
                      <Link to="#;" className="btn btn-danger">
                        Delete
                      </Link>
                      */}
            </div>
          </div>
          <div className="settings-widget">
            <div className="settings-inner-blk p-0">
              <div className="checkout-form personal-address add-course-info">
                <div className="personal-info-head">
                  <h4>Parent Details</h4>
                </div>
                <form action="#">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">First Name</label>
                        <p>{parentInfo ? parentInfo[0].name : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Last Name</label>
                        <p>{parentInfo ? parentInfo[0].surname : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Phone</label>
                        <p>{parentInfo ? parentInfo[0].phone : ""}</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-control-label">Email</label>
                        <p>{parentInfo ? parentInfo[0].email : ""}</p>
                      </div>
                    </div>
                    <div className="update-profile d-flex justify-content-between">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() =>
                          navigate(`/parent/parent-profile-edit`)
                        }
                      >
                        Update Profile
                      </button>

                      <Link to="/newpassword" className="btn btn-warning">
                        Change Password
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
